import { useTranslation } from 'react-i18next'
import React from 'react'

import { useForm, useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveScreenView } from './_requests/saveScreenView'
import Form from '../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import Switch from '../../../components/form/Switch'

const ScreenViewForm = () => {
  const { t } = useTranslation('screenViews')
  const { view } = useModalData()
  const form = useForm()
  const { handleChange } = useFormState()

  const isNewViewLabel = !form.id ? t('registeringNew') : `${t('updatingView')}: ${view?.name}`

  return (
    <>
      <FormItem label={t('viewName')} field="name" />

      <Separator weight={4} />

      {view.id && (
        <Switch
          value={!!form.id}
          onChange={value => handleChange('id', !value ? undefined : view.id)}
          label={isNewViewLabel}
        />
      )}

      <Separator weight={2} />
    </>
  )
}

const Wrapper = () => {
  const { view } = useModalData()
  const [save, { loading }] = useSaveScreenView()

  return (
    <Form onSubmit={!loading ? save : undefined} initialState={{ name: '', ...view }}>
      <ScreenViewForm />
      <SubmitBar loading={loading} />
    </Form>
  )
}

export default Wrapper
